import moment from "moment-timezone";

import { toTitleCase } from "@/utils/filters";

import { medicationLabelMapper } from "../helpers/medicationLabelMapper";
import { RATING_OPTIONS_NONE_MUCH_LABEL_MAP } from "../../../constants/rating-options";

export const LABEL_MAP = [
  {
    col: 1,
    formatter: (_option, medication) => moment.utc(medication.date).local().format("MM/DD/YYYY"),
    key: "date",
    label: "Date",
  },
  { col: 2, key: "medication_name", label: "Medication" },
  { col: 1, key: "dosage", label: "Dosage" },
  { col: 1, key: "amount", label: "Amount" },
  { col: 2, formatter: medicationLabelMapper, key: "adherence", label: "Adherence" },
  { col: 1, formatter: medicationLabelMapper, key: "benefits", label: "Benefits" },
  { col: 2, formatter: medicationLabelMapper, key: "side_effect", label: "Side Effects" },
  {
    col: 2,
    formatter: (option, medication) => toTitleCase(medication.med_changes),
    key: "med_changes",
    label: "Med Changes",
  },
];

export const MEDICATION_IMPACT_SECTIONS = [
  {
    key: "benefits",
    labels: RATING_OPTIONS_NONE_MUCH_LABEL_MAP,
    title: "Medication Benefits",
  },
];
